module.exports = __webpack_public_path__ + "img/6.6dfa7b9f.jpg";